import { render, staticRenderFns } from "./DatosEnvio.vue?vue&type=template&id=6407b83e"
import script from "./DatosEnvio.vue?vue&type=script&lang=js"
export * from "./DatosEnvio.vue?vue&type=script&lang=js"
import style0 from "./DatosEnvio.vue?vue&type=style&index=0&id=6407b83e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports